<template>
<div>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead>
                    <tr>
                        <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index" :style="loadStyle(index)">
                            <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                            <span v-if="item == 'Action'" style="float:right">{{item}}</span>
                            <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="7">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id" @click="goDetail(id)" class="rows">
                                    <td v-for="(item, index) in td" :key="index" :style="loadStyle(index)">
                                        <template v-if="item == 'pengajuanStart' || item == 'pengajuganEnd' || item == 'tanggalInsert' || item == 'tanggalApprove'">
                                            {{body[item]}}
                                        </template>
                                        <template v-else>
                                            <template v-if="item == 'approve'">
                                                <span class="font-weight-bold" :style="{ color : body['warna'] }">{{body[item]}}</span>
                                            </template>
                                            <template v-else>
                                                <template v-if="item == 'totalJam'">
                                                    <span >{{body[item]}}</span>
                                                </template>
                                                <template v-else>
                                                    <template class="numbering" v-if="item == 'no'">
                                                        <span>{{id+1}}.</span>
                                                    </template>
                                                    <template v-else>
                                                        <span :title="body[item]">
                                                            {{body[item]}}
                                                        </span>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead>
                            <tr>
                                <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index">
                                    <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                                    <span v-if="item == 'Action'" style="float:right">{{item}}</span>
                                    <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="5">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(body, id) in data" :key="id" @click="goDetail(id)" class="rows">
                                <td v-for="(item, index) in td" :key="index">
                                    <template v-if="item == 'pengajuanStart' || item == 'pengajuganEnd' || item == 'tanggalInsert' || item == 'tanggalApprove'">
                                        {{body[item]}}
                                    </template>
                                    <template v-else>
                                        <template v-if="item == 'approve'">
                                            <span class="font-weight-bold" :style="{ color : body['warna'] }">{{body[item]}}</span>
                                        </template>
                                        <template v-else>
                                            <template v-if="item == 'totalJam'">
                                                <span >{{body[item]}}</span>
                                            </template>
                                            <template v-else>
                                                <template class="numbering" v-if="item == 'no'">
                                                    <span>{{id+1}}.</span>
                                                </template>
                                                <template v-else>
                                                    <span :title="body[item]">
                                                        {{body[item]}}
                                                    </span>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
export default {
    props: ['data', 'th', 'td', 'styleTable', 'errors'],
    data() {
        return {
            sortIcon: [],
        }
    },
    mounted() {
        this.iconLoad('unsort', 'none')
    },
    methods: {
        clickThead(index) {
            this.$emit('sort', index)
            this.iconLoad('sort', index)
        },
        goDetail(id) {
            this.$emit('detail', id)
        },
        loadStyle(index) {
            return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index]
        },
        iconLoad(type, index) {
            this.sortIcon = []
            let length = this.th.length
            var i = 0
            if (type == 'sort') {
                for(i=0;i<length;i++) {
                    let onPush = ''
                    if(index == i) {
                        onPush = require('../assets/menu/sort_normal.svg')
                    } else {
                        onPush = require('../assets/menu/sort_active.svg')
                    }
                    this.sortIcon.push(onPush)
                }
            } else {
                for(i=0;i<length;i++) {
                    let onPush = require('../assets/menu/sort_active.svg')
                    this.sortIcon.push(onPush)
                }
            }
        },
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 4px;
    padding-right: 4px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 4px;
    padding-right: 4px;
    text-align: left;
}
td,th {
    /* overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap; */
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.status {
    width: 80px;
    height: 20px;
    color: white;
    border-radius: 4px;
    float: right;
    text-align: center;
}
.statusBaru {
    background-color: rgba(255, 209, 70, 1);
}
.statusDitolak {
    background-color: rgba(255, 0, 0, 1);
}
.statusDisetujui {
    background-color: rgba(94, 189, 116, 1);
}

.numbering {
    text-align: center !important;
}
.rows:hover {
    cursor: pointer;
    background-color: whitesmoke;
}
</style>